module.exports = __webpack_public_path__ + "static/media/red_chip.ee957103.png";